import { render, staticRenderFns } from "./PdnaItem.vue?vue&type=template&id=76b70ce8"
import script from "./PdnaItem.vue?vue&type=script&lang=js"
export * from "./PdnaItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports